// functions to be highlighted
export const highlightedFunctionNames = [
    'onUserEvent',
    'onCreateProject',
    'onCreateUser',
    'onCleanupUser',
    'onVisualState',
    'follow',
    'title',
    'context',
    'require',
    'intent',
    'reply',
    'fallback',
    'visualHints',
    'visual',
    'onEnter',
    'onCreateContext',
    'onCreate',
    'onCleanup',
    'print',
    'recognitionHints',
    'voice',
    'question',
    'answers',
    'homophone',
    'noContext',
    'DateTime',
    'opts',
    'corpus',
    'document',
    'window',
    'atob',
    'requestAnimationFrame',
    'act',
];

// objects to be highlighted
export const highlightedObjectNamesWithDot = [
    'visualState',
    'visual',
    'authData',
    'auth',
    'projectAPI',
    'project',
    'api.async',
    'api.crawl_v1', 
    'api.table_v1', 
    'api.query_v1', 
    'api.corpus_v1', 
    'api.corpus', 
    'api.generator_v1',
    'api.createCodeIndex',
    'api.createApiStubs',
    'api.convertOpenApiSpecToJson',
    'api.generateStubs',
    'api.generateJsonByOpenApiSpec',
    'api.connect',
    'api.disconnect',
    'api.versions',
    'api.submitCorpus',
    'api.indexStatus',
    'api.restartIndexing',
    'api.deleteIndex',
    'api.dot2svg',
    'api.imageUrl',
    'api.html2md',
    'api.html2md_v2',
    'api.pdf2md',
    'api.defaultCrawler',
    'api.createUI',
    'api.getConfig',
    'api.getHttpHeaders',
    'api.getCorpuses',
    'api.visualize',
    'transforms',
];

// nodejs keywords (for commonjs modules)
export const commonJsKeywords = [
    'exports'
];

// predefined names for syntax checker
export const highlightedObjectNames = [
    'clientAPI',
    'api',
    '_',
    'async',
    'noctx',
    'projectAPI',
    'project',
    'transforms',
];

export const highlightedFunctions = highlightedFunctionNames;

export const highlightedObjects = highlightedObjectNames;

export const highlightedObjectWithDot = highlightedObjectNamesWithDot;
